var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcSucess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -1.16626,
    y: -1.20898,
    width: 20.4167,
    height: 20.4167,
    rx: 7.82609,
    fill: "#32BA7C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.97157 8.32872L8.07923 10.4093L12.028 5.62364C12.3543 5.22831 12.9392 5.17227 13.3345 5.49847C13.7298 5.82468 13.7859 6.40959 13.4597 6.80492L8.86512 12.3731C8.51819 12.7936 7.8853 12.8259 7.49736 12.4429L4.66766 9.64962C4.3029 9.28956 4.2991 8.70198 4.65916 8.33722C5.01923 7.97246 5.60681 7.96866 5.97157 8.32872Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.32971 -1.20996H12.754C16.3417 -1.20996 19.2502 1.69849 19.2502 5.28625V12.7105C19.2502 16.2983 16.3417 19.2067 12.754 19.2067H5.32971C1.74195 19.2067 -1.1665 16.2983 -1.1665 12.7105V5.28625C-1.1665 1.69849 1.74195 -1.20996 5.32971 -1.20996ZM5.32971 0.6461C2.76702 0.6461 0.689557 2.72357 0.689557 5.28625V12.7105C0.689557 15.2732 2.76702 17.3506 5.32971 17.3506H12.754C15.3166 17.3506 17.3941 15.2732 17.3941 12.7105V5.28625C17.3941 2.72357 15.3166 0.6461 12.754 0.6461H5.32971Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSucess);
export default __webpack_public_path__ + "static/media/ic_sucess.f6a1c04822be453ee9d5d21837cc0a51.svg";
export { ForwardRef as ReactComponent };